<template>
  <div class="tXimaHistoryParentDiv">
    <div :style="{
      position: 'relative',
      backgroundColor:HNewGameUIConfig.newGameUIType === 3?'#1f1f1f':'white',
      borderRadius:'10px',
    }">
      <div :style="{
        backgroundColor:hcf.getMainColor()+'66',
      }" class="topDivStyle">
        <div style="
          padding:5px;
          border-bottom-left-radius: 10px;
          border-bottom-right-radius: 10px;
          display: flex;flex-direction: column;justify-content: flex-end;align-items: center;">
          <div :style="hcf.getTextStyle({
            addSize:-1,
        })">有效投注额
          </div>
          <div :style="hcf.getTextStyle({
          addSize:3,color:'main',fontWeight:'bold'
        })">{{ validBetAmount }}
          </div>
        </div>
        <div style="
          padding:5px;
          border-bottom-left-radius: 10px;
          border-bottom-right-radius: 10px;
          display: flex;flex-direction: column;justify-content: flex-end;align-items: center;">
          <div :style="hcf.getTextStyle({
            addSize:-1,
        })">返水金额
          </div>
          <div :style="hcf.getTextStyle({
          addSize:3,color:'main',fontWeight:'bold'
        })">{{ rebateAmount }}
          </div>
        </div>
      </div>
      <div :style="{
        display: 'flex',
        flexDirection: 'row',
        alignItems:'center',
        backgroundColor: hcf.getMainColor()+'44',
      }">
        <div :style="{
              width: '20%',
              backgroundColor:'main',
              padding:'5px 0',
            }" v-for="(each,eachIndex) in ['洗码时间','有效投注','注单数','输赢','流水金额']" :key="eachIndex">
          <div :style="hcf.getTextStyle({
                textAlign:'center',addSize:-3,fontWeight:'bold',
            })">
            {{ each }}
          </div>
        </div>
      </div>
      <div style="background-color: var(--ct-main-bg-color);">
        <HList :respCallback="listCallback" path="/app/rebate/statistics" :disablePullRefresh="true">
          <template #default="{ item,index }">
            <div @click="clickEachRowData(item)" style="display: flex;flex-direction: row;align-items: center;">
              <div :style="{
              width: '20%',
              backgroundColor:index%2 !== 0 ?'white':'#DAE9FE11',
              padding:'5px 0',
              alignItems: 'center',
              justifyContent:'center',
              display:'flex',
            }" v-for="(each,eachIndex) in item" :key="eachIndex">
                <div :style="hcf.getTextStyle({
                  textAlign:'center',addSize:-2,color:eachIndex===4?'#E08900':''
                 })">
                  {{ eachIndex === 0 ? formatToMonthDayTime(each) : each }}
                </div>
                <van-icon v-if="eachIndex === 4" name="arrow" size="13" style="color: var(--ct-main-color)"/>
              </div>
            </div>
          </template>
        </HList>
      </div>
    </div>
  </div>
</template>


<script setup>
  import {useUserStore} from "@/stores/useUser.js";
  import HList from "@/components/utils/HList.vue";
  import {hcf} from "@/components/utils/HComFunctions.js";
  import {hr} from "@/components/utils/HRouter.js";
  import {useHHttp} from "@/hooks/useHHttp.js";
  import HNewGameUIConfig from "@/components/utils/HNewGameUIConfig.js";
  const http = useHHttp();
  const user = useUserStore();
  const validBetAmount = ref(0);
  const rebateAmount = ref(0);


  function clickEachRowData(item){
    hr.go("rebate-detail",item);
  }


  function listCallback(resp) {
    validBetAmount.value = resp['ValidBetAmount'] ?? '';
    rebateAmount.value = resp['RebateAmount'] ?? '';
  }

  function formatToMonthDayTime(datetimeStr) {
    const date = new Date(datetimeStr.replace(/-/g, '/')); // 替换是为了兼容 Safari
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    return `${month}/${day}`;
  }
</script>


<style scoped>

  .tXimaHistoryParentDiv {
    display: flex;
    flex-direction: column;
  }

  .topDivStyle{
    border-top-left-radius: 10px;
    border-top-right-radius: 10px;
    display:flex;flex-direction:row;justify-content:space-around;
  }
</style>
